// @flow
import React from 'react';
import { getIn, useFormikContext } from 'formik';
import { useParams } from 'react-router-dom';

import { PaddedAndRaisedSegment } from '../../presentational/PaddedAndRaisedSegment';
import { ClusterInputTable } from '../../cluster/cluster-input-table/ClusterInputTable';
import {
  NATIVE_INFERENCE_POOL_CCU_MONTHLY_INPUTS_JSON_CONFIG,
  NATIVE_INFERENCE_POOL_CCU_MONTHLY_INPUTS_FORM,
} from '../../../constants';
import { isAnythingEditedOnNativeInferencePoolPageBesidesTheGivenForm } from '../../cluster/cluster-details-inputs/utils';
import { toastError } from '../../presentational/notifications/utils';
import { useUpdateNativeInferencePoolMutation } from '../../../service-definitions/estimates';
import { useEstimateVersion } from '../../../custom-hooks/useEstimateVersion';

export const NativeInferencePoolComputeBasedUsageContainer = () => {
  const { estimateId, nativeInferencePoolId } = useParams();
  const [updateNativeInferencePool] = useUpdateNativeInferencePoolMutation();
  const estimateVersion = useEstimateVersion();

  const rowsConfig = [
    {
      backendName: 'is_enabled',
      displayName: 'Active',
      isBooleanField: true,
    },
    {
      backendName: 'ccu_count',
      displayName: 'CCUs',
    },
  ];

  const { values, initialValues } = useFormikContext();

  const shouldBeDisabled = isAnythingEditedOnNativeInferencePoolPageBesidesTheGivenForm(
    values,
    initialValues,
    NATIVE_INFERENCE_POOL_CCU_MONTHLY_INPUTS_FORM
  );

  return (
    <PaddedAndRaisedSegment disabled={shouldBeDisabled}>
      <ClusterInputTable
        disabled={shouldBeDisabled}
        keyNameInValues={NATIVE_INFERENCE_POOL_CCU_MONTHLY_INPUTS_JSON_CONFIG}
        rowsConfig={rowsConfig}
        tableName="Inference Pool Compute-Based Monthly Usage"
        updateFunc={async () => {
          const valuesToSendToBackend = getIn(
            values,
            NATIVE_INFERENCE_POOL_CCU_MONTHLY_INPUTS_JSON_CONFIG
          );
          const nativeInferencePoolCcuInputs = Object.values(valuesToSendToBackend.months);
          const payload = {
            id: nativeInferencePoolId,
            estimate_id: estimateId,
            estimate_version: estimateVersion,
            [NATIVE_INFERENCE_POOL_CCU_MONTHLY_INPUTS_JSON_CONFIG]: {
              inputs: nativeInferencePoolCcuInputs,
            },
          };
          const { error } = await updateNativeInferencePool({
            estimateId,
            nativeInferencePoolId,
            payload,
          });
          if (error) {
            toastError(error);
          }
        }}
      />
    </PaddedAndRaisedSegment>
  );
};
